import React from 'react'
import PropTypes from 'prop-types'

import '@loyal_molecules/header.css'
import '@loyal_molecules/menu-toggle.css'
import '@loyal_template/base.css'

const HeaderWrapper = ({ children, className }) => {
  return (
    <div id='header-connected' className={`container-header bg-brand-2 container-fluid pt-0 d-print-none d-md-flex align-items-center ${className || ''}`} role='banner'>
      <div className='w-100 h-100'>
        <div className='container container-with-zoom h-100 mx-md-auto'>
          <div id='header' className='header row row-eq-height h-100'>
            {children}
          </div>
        </div>
      </div>
    </div>
  )
}

HeaderWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string
}

export default HeaderWrapper



// WEBPACK FOOTER //
// ./src/App/Header/HeaderWrapper.js